export default function hasArabic(text: string | null): boolean {
  if (text) {
    const arabicRegex =
      /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/
    return arabicRegex.test(text)
  }
  return true
}

/** Returns true if more than 40% of non-space characters are Arabic — use for RTL direction detection. */
export function isArabic(text?: string): boolean {
  if (!text) return false
  const total = text.replace(/\s/g, "").length
  if (!total) return false
  const arabic = (text.match(/[\u0600-\u06FF]/g) || []).length
  return arabic / total > 0.4
}
